import { useMantineTheme } from "@mantine/core";
import { IconDropletHalf2Filled, IconSlice, IconTrees } from "@tabler/icons-react";

import type { Translatable } from "../../../common/Dictionary";
import { translate } from "../../../common/Dictionary";
import type { PieChartConfig } from "../PieChartConfig";

export function useByVolumePieChartConfig(): PieChartConfig[] {
  const theme = useMantineTheme();
  return [
    {
      title: "Holzsorten",
      subline: "Volumen",
      icon: IconTrees,
      color: theme.colors.green,
      dataKey: "woodTypeStatistics.volumeByWoodType",
      dataNameKey: "woodType",
      dataValueKey: "volume",
      dataNameTranslator: (name: string) => translate(name as Translatable),
    },
    {
      title: "Feuchtigkeit",
      subline: "Volumen",
      icon: IconDropletHalf2Filled,
      color: theme.colors.blue,
      dataKey: "humidityLevelStatistics.volumeByHumidityLevel",
      dataNameKey: "humidityLevel",
      dataValueKey: "volume",
      dataNameTranslator: (name: string) => translate(name as Translatable),
    },
    {
      title: "Schnittlänge",
      subline: "Volumen",
      icon: IconSlice,
      color: theme.colors.yellow,
      dataKey: "cuttingLengthStatistics.volumeByCuttingLength",
      dataNameKey: "cuttingLength",
      dataValueKey: "volume",
      dataNameTranslator: (name: string) => translate(name as Translatable),
    },
  ];
}
